import { render, staticRenderFns } from "./Dock.vue?vue&type=template&id=2d99e1ae&scoped=true&"
import script from "./Dock.vue?vue&type=script&lang=js&"
export * from "./Dock.vue?vue&type=script&lang=js&"
import style0 from "./Dock.vue?vue&type=style&index=0&id=2d99e1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d99e1ae",
  null
  
)

export default component.exports